import { Component, OnInit } from '@angular/core';
import { UtilidadesService } from '../utilidades/utilidades.servicios.index';

@Component({
	selector: 'app-about-us',
	templateUrl: './about-us.component.html',
	styleUrls: ['./about-us.component.scss', '../../CSS/Sitio.css']
})
export class AboutUsComponent implements OnInit {
	public imgUrl = './assets/images/Quienes_Somos.png';
	constructor(public Utilidades: UtilidadesService) { }

	ngOnInit() {
	}

}